import { render, staticRenderFns } from "./vMenu.vue?vue&type=template&id=17cf7bb8&"
import script from "./vMenu.vue?vue&type=script&lang=js&"
export * from "./vMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports